import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export class OEZeissUVWelcomeView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                welcome:            'Welcome to\nthe',
                explorer:           'ZEISS\nEyeExplorer',
                sneakPreview:       'Sneak Preview*',
                techInnovation:     'Technology & Innovation\n*online until 31 December 2018'
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onRef = this.onRef.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);

        this.timeout = setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);

        if(this.timeout)    {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
    }

    onTimeout() {
        this.timeout = 0;

        if(!this.ref)   {
            this.timeoutCall = true;
            return;
        }

        this.ref.setOpen(true);
        
        this.timeoutCall = false;
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            welcome:            si.getLocalizedStringEnc('start_view_zeiss_welcome'),
            explorer:           si.getLocalizedStringEnc('start_view_zeiss_explorer'),
            sneakPreview:       si.getLocalizedStringEnc('start_view_zeiss_sneak_preview'),
            techInnovation:     si.getLocalizedStringEnc('start_view_zeiss_tech_innovation')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
        if(ref && this.timeoutCall) this.onTimeout();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    className="zeiss-uv-welcome-view"
                    isOpen={this.props.isOpen}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onToggle={this.props.onToggle}
                    ref={this.onRef}
                >

                    <div className="content">
                        <img className="logo" src="images/logo_zeiss.png" />
                        <span className="line line-1">{OEToolbox.stringToHtml(this.state.strings.welcome)}</span>
                        <span className="line line-2">{OEToolbox.stringToHtml(this.state.strings.explorer)}</span>
                        <span className="line line-3">{OEToolbox.stringToHtml(this.state.strings.sneakPreview)}</span>
                        <span className="line line-4">{OEToolbox.stringToHtml(this.state.strings.techInnovation)}</span>
                    </div>

                </OEStdModalController>
            </React.Fragment>
        );
    }
}

OEZeissUVWelcomeView.defaultProps = {
    moduleId:               ''
};

OEZeissUVWelcomeView.propTypes = {
    moduleId:               PropTypes.string,
    isOpen:                 PropTypes.bool,
    onOpenStateChanged:     PropTypes.func,
    onToggle:               PropTypes.func,
    fref:                   PropTypes.func
};

export default frefFromRef(OEZeissUVWelcomeView);